import { useRoute } from "@bcm-dev/bcms-vite";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";
import "./mobile.css";

/**
 * @function UINotifiHeader
 * @param {STRING} headerText - This is the header text 
 * @param {STRING} className - Additional classes to add to the custom accordion element
 * @param {React.Component} children - Allows us to inject other components and content.
 * @return {React.Component}
 * @exported true
 * @description This is the header used on all of the notifi pages.
 * @example
 * <UINotifiHeader>
 *  <p>Right column content goes here </p>
 * </UINotifiHeader>
 */
export default function UINotifiHeader(props) {
  const headerText = props.headerText ?? "[headerText]";
  const className = props.className ?? "";
  const point = props["data-point"] ?props["data-point"] : props.dataPoint ?? "";

  const navigate = useRoute();  
    let onClick = () => {        
            navigate(`/notifications/`);        
    }
  return (
    <div className={`${className} ui-notifi-header`}>
      <div className="flex-container notifi-header-container">
        <div className="flex-width flex-container flex-horizontal align-center">
          <div className="set-width">
            <SVGAsset onClick={onClick} id="LeftArrowIcon" className="light-text clickable back-arrow" data-point={`${point}_Backbutton`}/>
          </div>
          <div className="flex-width">
            <span className="light-text header-text"> <span data-point={`${point}`}>{headerText}</span></span>
          </div>
        </div>
        <div className="set-width right-column">
          { props.children }
        </div>
      </div>
    </div>
  );
}